import * as firebase from 'firebase/app';
import Class from '../models/Class.js';
require('firebase/firestore');

const state = {
  classes: [],
  days: [],
  classToEdit: {}
};

const getters = {
  getClasses: state => state.classes,
  getDays: state => state.days,
  getClassToEdit: state => state.classToEdit
};

const actions = {
  getAllClasses({
    commit
  }) {
    firebase.firestore().collection("classes").orderBy("day").onSnapshot(
      snapshot => {
        commit("setLoading", true);

        let classes = [];
        snapshot.forEach(doc => {
          let c = new Class(doc.id, doc.data().day, doc.data().dayAbbrev, doc.data().description, doc.data().period, doc.data().time, doc.data().title);
          classes.push(c);
        });
        commit("setClasses", classes);
        commit("setDays", classes);
        commit("setLoading", false);
      }, error => {
        commit("setLoading", false);
        console.error(error);
      }
    );
  }
};

const mutations = {
  setClasses(state, classes) {
    state.classes = classes;
  },
  setDays(state, classes) {
    let days = [{
        index: 1,
        name: "Monday",
        dayAbbrev: "M",
        classes: []
      },
      {
        index: 2,
        name: "Tuesday",
        dayAbbrev: "T",
        classes: []
      },
      {
        index: 3,
        name: "Wednesday",
        dayAbbrev: "W",
        classes: []
      },
      {
        index: 4,
        name: "Thursday",
        dayAbbrev: "R",
        classes: []
      },
      {
        index: 5,
        name: "Friday",
        dayAbbrev: "F",
        classes: []
      },
      {
        index: 6,
        name: "Saturday",
        dayAbbrev: "Sa",
        classes: []
      },
      {
        index: 0,
        name: "Sunday",
        dayAbbrev: "Su",
        classes: []
      },
    ];

    classes.sort((a, b) => (a.time > b.time) ? 1 : ((b.time > a.time) ? -1 : 0));

    classes.forEach((c) => {
      let i = c.day;
      days.find(p => p.index == i).classes.push(c);
      // days[i].classes.push(c);
    });

    state.days = days;
  },
  setClassToEdit(state, c) {
    state.classToEdit = c;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};